package link.erpango.quip.domain.noteimport

import link.erpango.quip.domain.entities.DVehicle

/**
 * Marks draft vehicles that are already in the garage ([VehicleDraft.garageMatchVin]) so the
 * review can warn "Ya tienes este vehículo" and attach maintenances/parts to the existing one
 * instead of creating a duplicate.
 *
 * Match order: same VIN, then same plate, then a brand + model that only one garage vehicle has.
 */
fun ImportDraft.matchGarage(garage: List<DVehicle>): ImportDraft {
    if (garage.isEmpty()) return this
    val taken = mutableSetOf<String>()
    val matched = vehicles.map { draft ->
        val match = garageMatchFor(draft, garage.filter { it.vin !in taken })
        match?.let { taken += it.vin }
        draft.copy(garageMatchVin = match?.vin)
    }
    return copy(vehicles = matched)
}

private fun garageMatchFor(draft: VehicleDraft, garage: List<DVehicle>): DVehicle? {
    draft.vin?.value?.let { vin -> garage.firstOrNull { normalizeVin(it.vin) == vin }?.let { return it } }
    draft.plate?.value?.let { plate -> garage.firstOrNull { normalizePlate(it.plate) == plate }?.let { return it } }
    val brand = draft.brand?.value ?: return null
    val model = draft.model?.value ?: return null
    // Without VIN or plate, only an unambiguous brand + model counts as the same vehicle.
    return garage.filter { sameText(it.brand, brand) && sameText(it.model, model) }.singleOrNull()
}

private fun sameText(a: String, b: String): Boolean = foldForMatch(a) == foldForMatch(b)
